import { getBackendUrl } from "@Utils";
import axiosWrapper from "@AxiosWrapper";
import type { UpdateGroupsDataRequest, UpdateGroupsDataResponse } from "@ServerTypes/groups/groups.schema";

/**
 * A row of the portal-wide Groups grid (`groups/getGroupsData` → the `Groups` collection).
 * Declared here (not derived) because `updateGroupsDataResponse.result` is `z.unknown()` — the one
 * response schema is shared by four different list getters, so it declares no row shape at all.
 */
export type GroupRow = {
  _id?: string;
  id?: string;
  name?: string;
  description?: string;
  count?: number;
  createdDate?: number;
  updatedDate?: number;
  updatedBy?: { _id?: string; name?: string };
};

export async function getGroupData({ value }: { value: UpdateGroupsDataRequest["value"] }) {
  const response = await axiosWrapper.post<UpdateGroupsDataResponse>(`${getBackendUrl()}/groups/updateGroupsData`, {
    value,
  });
  return response.data.result;
}
